/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable object-property-newline */
import React from 'react';
import isEqual from 'fast-deep-equal';
import P from '@leverege/promise';
import { Config } from '@leverege/plugin';
import { createConnect } from '@leverege/ui-plugin';
import { ValuesCache } from '@leverege/value-cache';
import { Auth, Constants } from '@leverege/api-redux';
import { DataSources } from '@leverege/ui-attributes';
import { UserSettings, Selection, UI } from '@leverege/ui-redux';
import { History } from '@leverege/molten-core';
import Key from "../utils/Key.js";
import { FilterSourcesModel } from "../../filters/index.js";
import ViewerModel from "../../dataViewers/layout/ViewerModel.js";
import OverridesReducer from "../../dataViewers/overrides/OverridesReducer.js";
import ReduxOverrides from "../../dataViewers/overrides/ReduxOverrides.js";
import Util from "./Util.js";
import Paginator from "./Paginator.js";
import DataViewers from "../../dataViewers/DataViewers.js";
import LayoutVersions from "../../dataViewers/layout/LayoutVersions.js";
import LayoutMethods from "../../dataViewers/layout/LayoutMethods.js"; // TMP
import Converter from "../../dataViewers/converter/ViewerModelConverter.js";
import { getQueryTrigger } from "../utils/QueryTriggers.js";
class AbstractGroupScreen extends React.PureComponent {
  static CLIENT = 'GroupScreen';
  constructor(props) {
    super(props);
    this.isInError = false;
    this.cache = new ValuesCache();
    this.paginator = new Paginator({
      onPageChange: this.onSetPage
    });
    this.overrides = new ReduxOverrides(props.settingsPath, {
      state: props.overrides
    });
    this.state = {};
    this.refreshTime = Config.get('GroupScreen', 'refreshTime', 30000);
    this.initialLoad = P.deferred();
    this.mobile = false;
    this.matchContext = {
      client: AbstractGroupScreen.CLIENT,
      clientType: props.clientType || AbstractGroupScreen.CLIENT,
      path: props.relationship?.path,
      objectType: props.relationship?.objectType,
      relationship: props.relationship,
      mobile: false
    };
    this.dataViewers = new DataViewers({
      ...this.matchContext,
      type: 'GroupDataViewer'
    });
    this.trigger = getQueryTrigger({
      loadData: this.loadData,
      objectType: props.relationship?.objectType,
      path: props.relationship?.path,
      client: AbstractGroupScreen.CLIENT,
      relationship: props.relationship,
      caches: new ValuesCache(),
      initialLoad: this.initialLoad
    }, this.getContext());
    LayoutMethods.install(this, {});
  }
  getContext() {
    const {
      targeted,
      relationship,
      layout
    } = this.props;
    const title = relationship.name;
    const {
      modifiedLayout
    } = this.state;
    const {
      filters,
      page,
      perPage
    } = this.getQueryOptions();
    return {
      ...this.matchContext,
      clientProps: this.props,
      mobile: this.mobile,
      target: DataSources.withData(Selection.getSelected(targeted)),
      title,
      filters,
      page,
      perPage,
      reloadData: this.loadData,
      onFilterChange: this.onUpdateFilter,
      onViewerChange: this.onViewerChange,
      getDataViewerProps: this.getDataViewerProps,
      layout: {
        ...layout,
        modifiedLayout,
        onLayoutChange: this.wrappedOnLayoutChange,
        onLayoutRevert: this.onLayoutRevert,
        onLayoutSave: this.onLayoutSave,
        onLayoutDelete: this.onLayoutDelete,
        onLayoutRename: this.onLayoutRename
      }
    };
  }

  /**
   * Returns the filters for the group. If necessary, this will reparse the
   * url query string
   * @returns An object containing { filters, page, perPage }
   */
  getQueryOptions(overrideLocation) {
    const {
      location: pLocation,
      baseFilter,
      baseSort,
      relationship
    } = this.props;
    const location = overrideLocation || pLocation;
    return this.cache.calc('query', () => {
      const q = Util.decodeQuery(location, {
        perPage: Config.get('GroupScreen', `${relationship?.path}/defaultPerPage`, Config.get('GroupScreen', 'defaultPerPage', 100)),
        page: 0
      });
      const {
        filters
      } = q;
      let nFilters = FilterSourcesModel.setBaseFilter(filters, baseFilter);
      nFilters = FilterSourcesModel.setBaseSort(nFilters, baseSort);
      if (filters !== nFilters) {
        return {
          ...q,
          filters: nFilters
        };
      }
      return q;
    }, location, baseFilter, baseSort);
  }
  getHiddenDataViewers() {
    return this.dataViewers.getFor('hidden');
  }

  /**
   * Invoked from within loadData to see if the load should really occur. Default to true
   * @returns {boolean} True if the data should be loaded
   */
  shouldLoadData() {
    return true;
  }

  /**
   * Request the data from the api server
   */
  loadData = async force => {
    const opts = force != null && typeof force === 'object' ? force : {
      force: force || false
    };
    const {
      force: forceRefresh,
      ...rest
    } = opts;
    if (this.unmounted || this.isInError && !opts.force) return;
    await this.trigger.preQuery?.();
    if (!this.shouldLoadData()) {
      await this.trigger.postQuery?.();
      return;
    }
    const {
      delegate,
      items,
      dispatch,
      defaultSort,
      defaultFilter
    } = this.props;
    const {
      filters,
      page,
      perPage
    } = this.getQueryOptions();
    let nextToken = null;
    // without this the loading screen flashes like crazy in between pages
    this.setState({
      loading: true
    });
    try {
      const maxOffset = Config.get('DeviceList', `${delegate.type}/maxOffset`, Config.get('DeviceList', 'maxOffset', 9999));
      if (page * perPage > maxOffset) {
        let getTo = page * perPage;
        let total = items?.total;
        let offset = maxOffset;
        let token = null;
        let limit = 1;
        do {
          // eslint-disable-next-line no-await-in-loop
          const res = await dispatch(delegate.search({
            limit: total ? Math.min(limit, getTo - offset) : limit,
            offset: token ? null : offset,
            filter: FilterSourcesModel.getFilter(filters) || defaultFilter || null,
            sort: FilterSourcesModel.getSort(filters) || defaultSort || null,
            nextToken: token
          }, {
            ...rest,
            ttl: 1000
          }));
          limit = 1000;
          total = res.total;
          token = res.nextToken;
          offset += res.items.length;
          getTo = Math.min(total, getTo);
        } while (offset < getTo);
        nextToken = token;
      }
      await dispatch(delegate.search({
        limit: perPage,
        offset: nextToken ? null : page * perPage,
        filter: FilterSourcesModel.getFilter(filters) || defaultFilter || null,
        sort: FilterSourcesModel.getSort(filters) || defaultSort || null,
        nextToken
      }, {
        ...rest,
        ttl: 1000
      }));
      this.isInError = false;
      if (!this.unmounted) {
        await this.trigger.postQuery?.();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      if (!this.unmounted) {
        await this.trigger.postQuery?.(err);
      }
      this.isInError = true;
    }
    if (this.unmounted !== true) {
      this.setState({
        loading: false
      });
    }
  };

  /**
   * Load data initially
   */
  componentDidMount() {
    this.unmounted = false;
    this.trigger.init?.();
  }
  componentWillUnmount() {
    this.trigger.cleanup?.();
    const {
      dispatch,
      targetKey = 'targeted'
    } = this.props;
    dispatch(Selection.clear('selected'));
    dispatch(Selection.clear('rollover'));
    dispatch(Selection.clear(targetKey));
    this.unmounted = true;
  }

  /**
   * Load the data on new location information
   */
  componentDidUpdate(prevProps) {
    const {
      location: ploc
    } = prevProps;
    const {
      location,
      dispatch,
      delegate
    } = this.props;
    if (ploc == null) {
      return;
    }
    const {
      filters: pSearch,
      page: pPage,
      perPage: pPerPage
    } = this.getQueryOptions(ploc);
    const {
      filters: search,
      page,
      perPage
    } = this.getQueryOptions(location);
    const df = !isEqual(FilterSourcesModel.getFilter(search), FilterSourcesModel.getFilter(pSearch));
    const ds = df || !isEqual(FilterSourcesModel.getSort(search), FilterSourcesModel.getSort(pSearch));
    const dm = ds || !isEqual(FilterSourcesModel.getMetadata(search), FilterSourcesModel.getMetadata(pSearch));
    if (ploc !== null && (ploc.pathname !== location.pathname || df || ds || dm || pPage !== page || pPerPage !== perPage)) {
      this.loadData();
    }
  }

  /**
   * Invoked on a paginator change.
   */
  onSetPage = ({
    page,
    perPage
  }) => {
    const {
      dispatch
    } = this.props;
    const {
      filters,
      perPage: oldPerPage,
      page: oldPage,
      ...rest
    } = this.getQueryOptions();
    const q = {
      filters,
      perPage,
      page,
      ...rest
    };
    const search = Util.encodeQuery(q);
    this.saveQueryParamsToSessionStorage(search);
    dispatch(History.push({
      search
    }));
  };
  onUpdateSettings = evt => {
    try {
      const {
        modifiedLayout
      } = this.state;
      const {
        settings
      } = this.props;
      const nSettings = ViewerModel[evt.data](modifiedLayout || settings, evt.value);
      this.setState({
        modifiedLayout: nSettings
      });
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error(ex);
    }
  };

  /**
   * Triggered on a change of the filters from a DataViewer. This will make sure
   * the filters have changed and a load request is needed.
   */
  onUpdateFilter = ({
    data,
    value,
    isOnMount,
    isOnUnmount
  }) => {
    // Calculate new filter from current
    const {
      dispatch
    } = this.props;
    const {
      filters,
      perPage,
      page,
      ...rest
    } = this.getQueryOptions();
    const nFilters = value == null ? FilterSourcesModel.removeSource(filters, data) : FilterSourcesModel.setSource(filters, data, value);
    // Check for change in filter and set page to zero
    const df = !isEqual(FilterSourcesModel.getFilter(nFilters), FilterSourcesModel.getFilter(filters));
    const ds = df || !isEqual(FilterSourcesModel.getSort(nFilters), FilterSourcesModel.getSort(filters));
    const dm = ds || !isEqual(FilterSourcesModel.getMetadata(nFilters), FilterSourcesModel.getMetadata(filters));
    if (df || ds || dm) {
      const search = Util.encodeQuery({
        ...rest,
        filters: nFilters,
        perPage,
        page: df ? 0 : page
      });
      this.saveQueryParamsToSessionStorage(search);
      if (!isOnUnmount) {
        dispatch(isOnMount ? History.replace({
          search
        }) : History.push({
          search
        }));
      }
    }
  };
  onViewerChange = (event, setStateCallback) => {
    const {
      dispatch
    } = this.props;
    const v = event.value;
    this.setState({
      modifiedLayout: v
    }, setStateCallback);
    dispatch(UI.set('expanded', null));
    dispatch(UI.set('expandedPathname', null));
  };
  wrappedOnLayoutChange = (...args) => {
    const {
      dispatch
    } = this.props;
    this.onLayoutChange(...args);
    dispatch(UI.set('expanded', null));
    dispatch(UI.set('expandedPathname', null));
  };
  createDataItems = results => {
    const {
      relationship,
      delegate
    } = this.props;
    const {
      page,
      perPage
    } = this.getQueryOptions();
    const type = relationship.objectType;
    const ref = delegate.getInterfaceUrl(); // TODO: Change to getRefUrl

    const {
      items
    } = results || {};
    return {
      status: results?.status || null,
      error: results?.error || null,
      loading: results?.status === 'api.interface.status.loading',
      perPage,
      page,
      count: results?.total || 0,
      items: items == null ? [] : items.map(device => {
        if (device == null) {
          return device;
        }
        return {
          id: device?.id,
          type,
          ref,
          data: device
        };
      })
    };
  };
  getTitle() {
    const {
      relationship,
      title
    } = this.props;
    return title || relationship.name;
  }
  getIcon() {
    const {
      relationship,
      icon
    } = this.props;
    return icon || relationship.getIcon('screenIcon');
  }
  getDataViewerProps = () => {
    const {
      dispatch,
      items,
      delegate,
      actions,
      match,
      location,
      history,
      profile,
      parentItem,
      loading,
      targetKey,
      overrides,
      settingsPath,
      settings,
      expanded
    } = this.props;
    const {
      loading: sLoading,
      modifiedLayout
    } = this.state;
    const currLayout = modifiedLayout || settings || {};
    const {
      filters,
      page,
      perPage
    } = this.getQueryOptions();
    const dataItems = this.cache.calc('items', this.createDataItems, items, page, perPage);
    this.overrides = this.overrides.update(overrides, settingsPath);
    return {
      ...this.matchContext,
      selectionKey: 'selected',
      rolloverKey: 'rollover',
      targetKey,
      parentItem,
      dispatch,
      match,
      location,
      history,
      profile,
      data: dataItems,
      delegate,
      actions,
      filters,
      loading: loading || sLoading,
      paginator: this.paginator,
      reloadData: this.loadData,
      settingsPath,
      onSettingsChange: this.onUpdateSettings,
      onFilterChange: this.onUpdateFilter,
      dataViewers: this.dataViewers,
      isMobile: this.mobile,
      overrides: this.overrides,
      layout: currLayout,
      expanded
    };
  };
  saveQueryParamsToSessionStorage(q) {
    sessionStorage.setItem(`q:${this.props.relationship.path}`, q);
    sessionStorage.setItem(`qc:${this.props.relationship.path}`, this.props.relationship.objRefUrl);
  }
  render() {
    return null;
  }
}

/**
 * Connect it
 */
const connect = createConnect(AbstractGroupScreen.CLIENT, (s, props) => {
  return {
    client: AbstractGroupScreen.CLIENT,
    objectType: props?.relationship?.objectType,
    path: props?.relationship?.path
  };
});
const US_OPTS = {
  returnPromise: false
};
function connectChild(component, ep, LayoutModel) {
  const extraProps = ep || {};
  return connect((state, props) => {
    const merged = {
      ...props,
      ...extraProps
    };
    const {
      delegate,
      relationship: {
        objectType,
        path
      },
      match,
      clientSubType
    } = merged;
    const client = AbstractGroupScreen.CLIENT;
    let clientType = merged.clientType || 'GroupScreen';
    if (props.clientType && props.overrideClientType) {
      clientType = props.clientType;
    }
    if (clientSubType) {
      clientType = `${clientType}.${clientSubType}`;
    }
    const settingsPath = Key.forSettings(clientType, path);
    const targetKey = Key.usingPersona(match, clientType, path);
    const layout = LayoutVersions.use({
      state,
      props: merged,
      client,
      clientType,
      path,
      objectType
    });
    let settings = layout?.layout;
    settings = settings || UserSettings.get(state, Util.getSettingsPath(merged, clientType, 'LayoutModel'), US_OPTS);
    if (settings == null) {
      // Updates old ViewerModel to LayoutModel
      const old = UserSettings.get(state, Util.getSettingsPath(merged, clientType), US_OPTS);
      settings = Converter.convert(old, {
        settingsRoot: settingsPath
      });
      settings = settings || (LayoutModel || ViewerModel).create();
    }
    const r = {
      loading: delegate.isLoading(state),
      profile: Auth.getProfile(state.auth),
      items: delegate.getList(state, {
        getAll: true
      }),
      selected: Selection.get(state, 'selected'),
      targeted: Selection.get(state, targetKey),
      targetKey,
      settingsPath,
      settings,
      overrides: OverridesReducer.getAll(state),
      layout,
      expanded: UI.get(state, 'expanded'),
      ...extraProps,
      clientType
    };
    return r;
  })(component);
}
export default AbstractGroupScreen;
export { connectChild };